import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import URL from '../../../utils/URL';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

export function getTutorSessionList(sort, date, pageNumber, itemsPerPage, callBack) {
    return function (dispatch) {
        let values = {
            sort,
            date,
            pageNumber,
            itemsPerPage,
        };
        Client.get(URL.IM_EDUCATOR.GET_TUTORAPPOINTMENT_SESSION_LIST, values, true)
            .then((response) => {
                myLog('====getTutorSessionList response ===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====getTutorSessionList error===????', error);
                callBack(false);
            });
    };
}

// export function sessionAppointmentCancel(values, callBack) {
//   return function () {
//     Client.DELETENEW(
//       URL.IM_EDUCATOR.CANCELATION_REQUEST_APPONTMENT_SESSION_LIST,
//       values,
//       true
//     )
//       .then((response) => {
//         myLog("====sessionAppointmentCancel response===::::", response);
//         callBack(response);
//       })
//       .catch((error) => {
//         myLog("====sessionAppointmentCancel error===????", error);
//         callBack(false);
//       });
//   };
// }

export function getNumberOfStudentsList(id, callBack) {
    return function () {
        Client.get(`${URL.IM_EDUCATOR.GET_NUMBER_OF_STUDENTS_LIST}/${id}/students`, {}, true)
            .then((response) => {
                myLog('====getNumberOfStudentsList response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====getNumberOfStudentsList error===????', error);
                callBack(false);
            });
    };
}

export const getEducatorAvailablityDays = (educatorId, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.COMMON_ENDPOINT.GET_EDUCATOR_AVAILABILITY_DAYS}?id=${educatorId}`,
            {},
            true
        )
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getEducatorSubject = (educatorId, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.COMMON_ENDPOINT.GET_SUBJECT}?educatorId=${educatorId}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getStudentHistory = (educatorId, id, values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.IM_EDUCATOR.GET_STUDENT_HISTORY}/${id}/history?educatorId=${educatorId}`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const submitAddNotes = (values, callBack) => {
    return function (dispatch) {
        Client.post(URL.COMMON_ENDPOINT.STUDENT_ADD_NOTES, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getAddNotesList = (id, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.COMMON_ENDPOINT.STUDENT_ADD_NOTES}?id=${id}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getEducatorSubCategoryList = (subjectId, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.COMMON_ENDPOINT.GET_SUB_CATEGORY}/${subjectId}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBCATEGORY_LIST,
                        payload: response.response.data,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
            });
    };
};

export const getAvailableStudentList = (params, callBack) => {
    return function (dispatch) {
        Client.get(URL.IM_EDUCATOR.AVAILABLE_STUDENT, params, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_STUDENT_LIST,
                        payload: response.response.data,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
            });
    };
};

export const createClassRoomSession = (data, callBack) => {
    return function (dispatch) {
        Client.post(URL.COMMON_ENDPOINT.CREATE_CLASSROOM_SESSION, data, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Create Classroom Session error===????', error);
            });
    };
};

export const updateClassRoomSession = (data, callBack) => {
    return function (dispatch) {
        Client.put(URL.COMMON_ENDPOINT.CREATE_CLASSROOM_SESSION, data, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Create Classroom Session error===????', error);
            });
    };
};

export const updateVisitThirdParty = (data, callBack) => {
    return function (dispatch) {
        Client.put(URL.COMMON_ENDPOINT.VISIT_THIRD_PARTY, data, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Update visit third party error===????', error);
                callBack(false);
            });
    };
};

// export const removeImageFromSession = (id, callBack) => {
//   return function (dispatch) {
//     Client.DELETE(`${URL.IM_EDUCATOR.REMOVE_IMAGES}/${id}`, null, true)
//       .then((response) => {
//         myLog("====attachment save response===::::", response.response);
//         callBack(response);
//       })
//       .catch((error) => {
//         myLog("====attchment save error===????", error);
//         callBack(false);
//       });
//   };
// };

export const fetchStudentAttendance = (values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.COMMON_ENDPOINT.FETCH_STUDENT_ATTENDANCE}/${values.sessionId}/students`,
            values,
            true
        )
            .then((response) => {
                myLog('====fetch student attendance response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====fetch student attendance error===????', error);
                callBack(false);
            });
    };
};

export const fetchBroadcastStudentDetails = (sessionId, values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.IM_EDUCATOR.GET_AVAILABE_BROADCAST_STUDENTS}?visitId=${sessionId}`,
            values,
            true
        )
            .then((response) => {
                myLog('====fetch student attendance response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====fetch student attendance error===????', error);
                callBack(false);
            });
    };
};

// export function getVisitInformation(visitId, callBack) {
//   return (dispatch) => {
//     Client.get(`${URL.IM_EDUCATOR.GET_VISIT_INFORMATON}/${visitId}`, null, true)
//       .then((response) => {
//         myLog("====getVisitInformation Action response===::::", response);
//         callBack(response);
//         if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
//           dispatch({
//             type: ACTION_TYPES.PHYSICIAN.GET_VISIT_INFORMATION,
//             payload: response.response,
//           });
//         }
//       })
//       .catch((error) => {
//         myLog("====getVisitInformation error===????", error);
//         callBack(false);
//       });
//   };
// }

export function getStudentInfoDate(studentId, callBack) {
    return function (dispatch) {
        myLog('====get user information ===::::');
        Client.get(`${URL.IM_EDUCATOR.GET_STUDENT_INFO_DATE}/${studentId}`, {}, true)
            .then((response) => {
                myLog('====get user information response===::::', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_STUDENT_INFO_DATE,
                        payload: response.response,
                    });
                }
                callBack(response);
            })
            .catch((error) => {
                myLog('====get user information error===????', error);
                callBack(false);
            });
    };
}

export const getSessionSummaryChatWithPagination = (visitId, values, callback) => {
    return (dispatch) => {
        Client.getV2(`${URL.IM_EDUCATOR.GET_VISIT_INFORMATON}/${visitId}/chat`, values, true)
            .then((response) => {
                myLog('====getSessionSummaryChatWithPagination ===::::response', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callback(response);
                }
            })
            .catch((error) => {
                myLog('====getSessionSummaryChatWithPagination ==?????error', error);
                callback(false);
            });
    };
};

export const getReferralStudentList = (id, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.IM_EDUCATOR.GET_REFERRAL_STUDENT_LIST}?institutionId=${id}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getEducatorForReferral = (
    sessionStartTime,
    sessionEndTime,
    visitId,
    values,
    callBack
) => {
    return function (dispatch) {
        Client.get(
            `${URL.IM_EDUCATOR.GET_EDUCATOR_FOR_REFERRAL}?sessionStartTime=${sessionStartTime}&sessionEndTime=${sessionEndTime}&visitId=${visitId}`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const submitReferralNotes = (values, callBack) => {
    return function (dispatch) {
        Client.post(URL.IM_EDUCATOR.SUBMIT_SESSION_REFERRAL, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const submitSubjectReferralNotes = (values, callBack) => {
    console.log('=====values in action====', values);
    return function (dispatch) {
        Client.post(URL.IM_EDUCATOR.SUBMIT_SUBJECT_REFERRAL, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getCreatedReferralList = (value, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.IM_EDUCATOR.GET_CREATED_REFERRAL_LIST}`, value, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Branch Admin Session List error===????', error);
                callBack(false);
            });
    };
};

export const getCompletedReferralList = (value, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.IM_EDUCATOR.GET_COMPLETED_REFERRAL_LIST}`, value, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Branch Admin Session List error===????', error);
                callBack(false);
            });
    };
};

export const getPreviousStudentList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.IM_EDUCATOR.GET_PREVIOUS_STUDENT_LIST, values, true)

            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getAllStudentList = (id, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.IM_EDUCATOR.GET_ALL_STUDENT_LIST}?institutionId=${id}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getStudentChatList = (id, values, callBack) => {
    return function (dispatch) {
        Client.get(
            `${URL.IM_EDUCATOR.GET_STUDENT_CHAT_LIST}?receiverUserId=${id}&isFile=${false}`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getEducatorFileUpload = (values, callBack) => {
    return function (dispatch) {
        Client.post(URL.IM_EDUCATOR.GET_EDUCATOR_FILE_UPLOAD, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getEducatorFileDownload = (fileId, values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.IM_EDUCATOR.GET_EDUCATOR_FILE_DOWNLOAD}?fileId=${fileId}`, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.EDUCATOR.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Subject error===????', error);
                callBack(false);
            });
    };
};

export const getUnreadPreviousUserList = (values, callBack) => {
    return function (dispatch) {
        // const values = {
        //   search,
        //   pageNumber,
        //   itemsPerPage,
        // };
        Client.get(URL.IM_STUDENT.GET_UNREAD_PREVIOUS_USER_LIST, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_UNREAD_PREVIOUS_USER_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====Unread Previous User List error===????', error);
                callBack(false);
            });
    };
};

export function getAllSessions(sort, date, pageNumber, itemsPerPage, callBack) {
    return function (dispatch) {
        let values = {
            sort,
            date,
            pageNumber,
            itemsPerPage,
        };
        Client.get(URL.IM_EDUCATOR.GET_ALL_SESSION_LIST, values, true)
            .then((response) => {
                myLog('====getStudentSessionList response  ./      ===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====getStudentSessionList error===????', error);
                callBack(false);
            });
    };
}

export function getBudSummary(visitId, callBack) {
    return function () {
        Client.put(`${URL.IM_EDUCATOR.JOIN_IN_PERSON_SESSION}/${visitId}/bud-summary`, {}, true)
            .then((response) => {
                myLog('====getBudSummary response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====getBudSummary error===????', error);
                callBack(false);
            });
    };
}
